import { adminSupportQueryKeys as e } from "../supportQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { supportApi as n } from "@maat/api-main";
//#region src/support/admin/useAdminCallbackStatsQuery.ts
var r = () => t({
	queryKey: e.callbackStats(),
	queryFn: () => n.adminCallbackStats()
});
//#endregion
export { r as useAdminCallbackStatsQuery };
